import CancellationPage from './CancellationPage';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';

// Selectors
import { getAppointment } from 'store/reducers/appointment/selectors';

const mapStateToProps = state => {
  return {
    appointmentDate: getAppointment(state)
  };
};

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    null
  )
)(CancellationPage);



// WEBPACK FOOTER //
// ./src/components/pages/Appointment/CancellationPage/CancellationPageContainer.js